import React from "react";
import styles from "../App.module.css";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { t } = useTranslation();

  return (
    <header className={styles.header}>

      <div className={styles.overlay}>
        <h1 className={styles.title}>{t("header.title")}</h1>
        <p className={styles.subtitle}>{t("header.subtitle")}</p>

        <div className={styles.contactInfo}>
          <p>
            📞 <a 
              href={`tel:${t("contact.phone")}`}
              aria-label={`Call Al Faraj Towing at ${t("contact.phone")}`}
              itemProp="telephone"
            >
              {t("contact.phone")}
            </a>
          </p>
          <p>
            📞 <a 
              href={`tel:${t("contact.phone1")}`}
              aria-label={`Call Al Faraj Towing at ${t("contact.phone1")}`}
              itemProp="telephone"
            >
              {t("contact.phone1")}
            </a>
          </p>
          <p>
            ✉️ <a 
              href={`mailto:${t("contact.email")}`}
              aria-label={`Email Al Faraj Towing at ${t("contact.email")}`}
              itemProp="email"
            >
              {t("contact.email")}
            </a>
          </p>
        </div>

        <a 
          href={`tel:${t("contact.phone")}`} 
          className={styles.ctaButton}
          aria-label="Call Al Faraj Towing Now for Emergency Service"
        >
          {t("contact.call")}
        </a>
      </div>
    </header>
  );
}

/* 
  ✅ This component is now simplified!
  - No Helmet (moved to SeoMeta.js)
  - No SEO logic
  - Just pure UI component
  - Better separation of concerns
*/